export default function getMediaFileCharacterLabel({ kind, translate, }) {
    if (kind === "avatar") {
        return translate("mediaFile:details.avatarOf");
    }
    if (kind === "conversation") {
        return translate("mediaFile:details.conversation", { defaultValue: "Conversation" });
    }
    return translate("gallery:mediaFilePreview.character");
}
